module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cindy Wang Brandt, Rachel Held Evans\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Cindy Wang Brandt")]), _vm._v(" writes about faith and parenting, miracles in the ordinary, and beauty in the margins, tapping out words from the 33rd floor of a high-rise in Kaohsiung, Taiwan, where she lives with her husband, two children, and a miniature Yorkie. Her blog and newsletter can be found at "), _c('a', {
    attrs: {
      "href": "http://cindywords.com/"
    }
  }, [_vm._v("cindywords.com")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16PqeBV/tc-custom/9781467452519.jpg?1728851792711",
      "alt": "This image is the cover for the book Parenting Forward"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Parenting Forward\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("A progressive Christian parenting book with a social-justice orientation")])]), _c('p', [_vm._v("How do we build a better world? One key way, says Cindy Wang Brandt, is by learning to raise our children with justice, mercy, and kindness.")]), _c('p', [_vm._v("In "), _c('i', [_vm._v("Parenting Forward ")]), _vm._v("Brandt equips Christian parents to model a way of following Jesus that has an outward focus, putting priority on loving others, avoiding judgment, and helping those in need. She shows how parents must work on dismantling their own racial, cultural, gender, economic, and religious biases in order to avoid passing them on to their children. “By becoming aware of the complex ways we participate in systems of inequal­ity or hierarchy,” she says, “we begin to resist systemic injustice ourselves, empower our children, and change our communities.”")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0